import { Lock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="grid min-h-[60svh] place-items-center">
      <section className="max-w-md rounded-xl border border-stone-200 bg-white p-6 text-center shadow-sm">
        <Lock className="mx-auto h-8 w-8 text-mango-orange" />
        <h1 className="mt-4 text-xl font-bold text-leaf-dark">Screen not found</h1>
        <p className="mt-2 text-sm text-stone-600">This admin route is not in the current sitemap.</p>
        <div className="mt-5">
          <Button onClick={() => navigate('/dashboard')}>Go Dashboard</Button>
        </div>
      </section>
    </div>
  )
}
